<template>
  <avs-card class="pb-4">
    <template v-slot:title>
      <v-toolbar class="mt-4 custom-toolbar bgTable" elevation="0">
        <v-text-field
          class="mr-8"
          clearable
          hide-details
          prepend-inner-icon="mdi-magnify"
          :label="$t('commons.search')"
          v-model="search"
        />

        <avs-createButton
          :spantext="
            $t('actions.create', {
              entity: $t('commons.drawer.authorisation').toLowerCase(),
            })
          "
          menu
          :name="
            $t('actions.new_female', {
              entity: $t('commons.drawer.authorisation').toLowerCase(),
            })
          "
          @click="handleOpenEditDialog()"
        >
        </avs-createButton>
      </v-toolbar>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10"
        dense
        :headers="headers"
        :no-data-text="$t('messages.information.no_data')"
        :items="items"
        :items-per-page="-1"
        :search="search"
        item-key="id"
        @dblclick:row="
          ($event, { item }) => {
            if (allow.duplicate(item)) {
              handleOpenEditDialog(item);
            }
          }
        "
      >
        <template v-slot:item.requested_amount="{ item }">
          {{ formatNumber(item.requested_amount) }}
        </template>
        <template v-slot:item.created_at="{ item }">
          {{ toDatetime(item.created_at) }}
        </template>
        <!-- <template v-slot:item.status="{ item }">
          <avs-chip :label="false">
            {{ item.status }}
          </avs-chip>
        </template> -->
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item)" />
        </template>
        <template v-slot:item.checked="{ item }">
          <div class="d-flex justify-center">
            <avs-button
              icon
              color="secondary"
              :iconI="'mdi-checkbox-multiple-outline'"
              label
              fab
              small
              @click.stop="handleOpenConfirmDialog(item)"
              :spantext="
                $t('actions.open', {
                  entity: $t('commons.drawer.authorisation').toLowerCase(),
                })
              "
            />
          </div>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-center">
            <avs-editButton
              @click.stop="handleOpenEditDialog(item)"
              :spantext="
                $t('actions.edit', {
                  entity: $t('commons.drawer.authorisation').toLowerCase(),
                })
              "
            />
            <avs-button
              icon
              color="secondary"
              :iconI="'mdi-eye'"
              label
              fab
              small
              @click.stop="handleOpenEditDialog(item)"
              :spantext="
                $t('actions.open', {
                  entity: $t('commons.drawer.authorisation').toLowerCase(),
                })
              "
            />

            <avs-deleteButton
              @click.stop="handleOpenDeleteDialog(item)"
              :spantext="
                $t('actions.delete', { entity: $t('commons.fieldtype').toLowerCase() })
              "
            />
          </div>
        </template>
      </v-data-table>
      <!-- v-html="document.description" -->

      <v-dialog v-model="confirmDialogIsOpen" width="40vw">
        <v-card>
          <v-card-title class="headline d-flex justify-center">
            {{ $t("messages.information.title") }}
          </v-card-title>
          <v-card-text class="text-center">
            <p>
              {{
                $t("messages.information.confirmation", {
                  entity: selectedItem?.staff_member.full_name,
                })
              }}
            </p>
            <v-icon large class="my-4" color="primary">mdi-help-circle-outline</v-icon>
          </v-card-text>
          <v-card-actions class="d-flex justify-center">
            <v-btn color="success" @click="confirmAction('accept')">
              <v-icon left>mdi-check</v-icon>
              {{ $t("commons.accept") }}
            </v-btn>
            <v-btn color="error" @click="confirmAction('reject')">
              <v-icon left>mdi-close</v-icon>
              {{ $t("commons.reject") }}
            </v-btn>
            <v-btn color="secondary" @click="confirmAction('close')">
              <v-icon left>mdi-close-circle-outline</v-icon>
              {{ $t("commons.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="editDialogIsOpen" width="40vw">
        <component
          v-model="selectedItem"
          :hasUniqueName="hasUniqueName"
          :is="editDialogContent"
          :isEditable="isEditable"
          @cancel="handleCancel"
          @error="handleError"
          @success="handleSuccess"
        />
      </v-dialog>

      <DeleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Notification"
      />
    </template>
  </avs-card>
</template>

<script>
import { toDatetime } from "@/utils/datetime";
import { AuthorisationDetailService } from "@/services";
import { mkUnique } from "@/utils/validator";

import DeleteDialog from "@/components/generics/dialogs/DeleteDialog.vue";
import AuthorisationEditor from "@/components/ri3/authorisation/AuthorisationEditor.vue";
import { Approved, Canceled, Pending } from "@/components/generics/status";

export default {
  name: "AuthorisationDetail",
  components: { DeleteDialog, AuthorisationEditor, Approved, Canceled, Pending },
  created() {
    this.fetchFieldTypes();
  },
  computed: {
    hasUniqueName: {
      get() {
        const names = this.items
          .filter((e) => e.name !== this.selectedItem?.name)
          .map((e) => e.name);
        return mkUnique(names, "name");
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("N° Matricule"),
          value: "vehicle.matricule",
          // class: "min-width-150",
          sortable: true,
        },
        {
          text: this.$t("Nombre de Litre"),
          value: "requested_amount",
          sortable: true,
          filterable: false,
        },
        {
          text: this.$t("commons.created_at"),
          value: "created_at",
          sortable: true,
          filterable: false,
        },
        {
          text: this.$t("commons.status.name"),
          value: "status",
          align: "center",
          sortable: true,
          filterable: false,
        },
        {
          text: "",
          value: "checked",
          align: "center",
          sortable: false,
          filterable: false,
        },

        {
          text: this.$t("commons.action"),
          value: "actions",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      isEditable: true,
      items: [],
      search: "",

      // basecomponents: Object.values(COMPONENT_ENUM),
      deleteDialogIsOpen: false,
      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined,
      confirmDialogIsOpen: false,
    };
  },
  methods: {
    toDatetime,
    fetchFieldTypes() {
      AuthorisationDetailService.getAll(this)
        .then((response) => {
          this.items = response;
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error",
            });
          }
        });
    },
    formatNumber(value) {
      if (!value) return "";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    handleOpenConfirmDialog(item) {
      this.selectedItem = item;
      this.confirmDialogIsOpen = true;
    },
    confirmAction(action) {
      this.confirmDialogIsOpen = false;
      switch (action) {
        case "accept":
          this.authorizeRequest(this.selectedItem);
          break;
        case "reject":
          this.rejectRequest(this.selectedItem);
          break;
        case "close":
          this.send(this.$t("messages.info.operation_canceled"), "info");
          break;
        default:
          break;
      }
    },
    authorizeRequest(item) {
      AuthorisationDetailService.authorize(item.id)
        .then(() => {
          this.handleSuccess();
        })
        .catch((error) => {
          const message =
            error?.response?.data?.state || this.$t("messages.error.operation_failed");
          this.handleError(message);
        });
    },
    rejectRequest(item) {
      AuthorisationDetailService.reject(item.id)
        .then(() => {
          this.send(this.$t("messages.success.rejected"), "success");
          this.handleSuccess();
        })
        .catch((error) => {
          const message =
            error?.response?.data?.state || this.$t("messages.error.operation_failed");
          this.handleError(message);
        });
    },
    handleStatusComponent(action) {
      return action.status;
    },
    handleOpenDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialogIsOpen = true;
    },
    handleOpenEditDialog(item) {
      this.selectedItem = undefined;
      this.isEditable = true;
      if (item) {
        this.selectedItem = item;
        this.isEditable = false;
      }
      this.handleOpenEditDialogByComponent();
    },
    handleOpenEditDialogByComponent() {
      this.editDialogIsOpen = true;
      this.editDialogContent = "AuthorisationEditor";
    },
    handleCancel() {
      this.selectedItem = undefined;
      this.deleteDialogIsOpen = false;
      this.editDialogIsOpen = false;
      this.editDialogContent = null;
    },
    handleError(message) {
      this.send(message || "Enter a valid email address.", "error");
    },
    handleSuccess() {
      this.handleCancel();
      this.$nextTick(() => {
        this.fetchFieldTypes();
        this.send(this.$t("messages.success.operation"), "success");
      });
    },
    handleDelete() {
      AuthorisationDetailService.delete(this.selectedItem.id)
        .then(() => {
          this.handleSuccess();
        })
        .catch((error) => {
          const message = error?.response.data?.state;
          this.handleError(message);
        });
    },
    send(msg, color) {
      this.$store.commit("app/message", { msg, color });
    },
  },
};
</script>
